/***
 * Created on 2023/9/5
 * @author: Adam Cheng <adamcheng@qnap.com>
 ***/
import React from 'react';
import {getAppCDNUrl, getCurrentDomainRegion} from "common/ServiceCommon";
import {useTranslation} from "react-i18next";


function ServiceAppItem({item}) {
    const { i18n } = useTranslation();

    const onClick = () => {
        const url = getCurrentDomainRegion() === 'CHINA' ? item.website.china : item.website.global;
        window.open(url, '_blank');
    }

    return (
        <li className="services-grid__item" onClick={onClick}>
            <div className="services-grid__item__icon">
                <img src={`${getAppCDNUrl()}/cloud_app${item.icon.normal}`} alt=""/>
            </div>
            <div className="services-grid__item__label">{item.name[i18n.language]}</div>
        </li>
    );
}

export default ServiceAppItem;